















import { defineComponent, watch } from '@vue/composition-api'
import { useGetters } from '../../store/useGetters'
import EditorPart from '../../components/editor/EditorPart.vue'
import SpeakerSelector from '../../components/editor/SpeakerSelector.vue'
import { useCursorMover } from '../../components/editor/useCursorMover'
import { CursorPosition } from '../../store/modules/editor'
import { moveCursor } from '../../components/editor/useCursorPendingMover'
import { useActions } from '../../store/useActions'

export default defineComponent({
  name: 'KaiEditor',
  components: { SpeakerSelector, EditorPart },
  props: {
    popupRoot: {
      //TODO: remove this
      required: true
    }
  },
  setup() {
    const { listSiblingTrackingClass } = useCursorMover()
    const { parts, pendingCursorPosition } = useGetters({
      parts: 'editor/parts',
      pendingCursorPosition: 'editor/pendingCursorPosition'
    })

    const { acknowledgeCursorMove } = useActions({
      acknowledgeCursorMove: 'editor/acknowledgeCursorMove'
    })

    watch(pendingCursorPosition, (position?: CursorPosition) => {
      position &&
        moveCursor(position.partId, position.position, acknowledgeCursorMove)
    })

    return { parts, listSiblingTrackingClass }
  }
})
